import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import ReceiptsTextBlock from 'src/app/organisms/Homepage/ReceiptsTextBlock/ReceiptsTextBlock';

const Receipts = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl', 'spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl', 'spacing-none', 'spacing-xl']}
    background='bg-tertiary'
  >
    <ReceiptsTextBlock />
  </SectionLayout>
);

export default Receipts;
